import DocumentosAnexos from './documentosAnexos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setMessageConclusaoAction } from '../../store/conclusao/actions';

import {
    handleChangeDocumentosAnexos,
    handleChangeDocumentosAnexosArray,
    handleChangeDocumentosAdministradorValueFlag,
    handleChangeDocumentosSocioPessoaFisicaDezMaisValueFlag,
    handleChangeDocumentosSocioPessoaFisicaMenosDezValueFlag,
    handleChangeDocumentosSocioPessoaJuridicaNacionalValueFlag,
    handleChangeDocumentosSocioPessoaJuridicaEstrangeiraValueFlag,
    handleChangeDocumentosProcuradorValueFlag,
    documentosDeleteFile,
    documentosArrayDeleteFile,
    adicionarSocioDezOuMais,
    adicionarSocioMenosDez
} from '../../store/documentosAnexos/actions';
import { warnFormIncompleteAction } from '../../store/associadoPJReducer/actions';

const getLoading = (documentosAnexosReducer) => {
    let keys = Object.keys(documentosAnexosReducer);
    return !!keys.find(key => documentosAnexosReducer[key] && documentosAnexosReducer[key].hasOwnProperty('asyncLoading') && documentosAnexosReducer[key].asyncLoading);
}

const mapStateToProps = (state, nextState) => ({
    documentosAnexos: state.documentosAnexosReducer,
    dadosIniciais_tipoDocumento: state.dadosIniciaisPFReducer.dadosIniciais_tipoDocumento,
    declaracaoEspecifica: state.declaracaoEspecificaReducer,
    loading: getLoading(state.documentosAnexosReducer),
    tipoPessoa: state.tipoCadastroReducer,
    associados: state.associadoPJReducer
});
const mapDispatchToProps = dispatch =>
    bindActionCreators({
        handleChangeDocumentosAnexos,
        handleChangeDocumentosAnexosArray,
        handleChangeDocumentosAdministradorValueFlag,
        handleChangeDocumentosSocioPessoaFisicaDezMaisValueFlag,
        handleChangeDocumentosSocioPessoaFisicaMenosDezValueFlag,
        handleChangeDocumentosSocioPessoaJuridicaNacionalValueFlag,
        handleChangeDocumentosSocioPessoaJuridicaEstrangeiraValueFlag,
        handleChangeDocumentosProcuradorValueFlag,
        documentosDeleteFile,
        documentosArrayDeleteFile,
        adicionarSocioDezOuMais,
        adicionarSocioMenosDez,
        setMessageConclusaoAction,
        warnFormIncompleteAction
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentosAnexos);